module.exports = __webpack_public_path__ + "static/media/18_pol_3.28_84.54.78cae1f4.png";